import { classnames } from '@aibees/shared/utils';
import { Button, Tooltip } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import { IconButton } from '../icon-button';
import * as Styled from './styles';
import * as SX from './sx';
import type { LookalikeButtonBaseProps as Props } from './types';

export const LookalikeButtonBase = memo(
  ({
    className,
    type = 'default',
    onClick,
    disabled,
    errorMessage,
    limitReached,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('LookalikeButton', className)}
        sx={SX.root}
      >
        <Tooltip title={limitReached ? errorMessage : null} placement="top">
          {type === 'icon' ? (
            <IconButton
              icon="plus"
              variant="outlined"
              size="small"
              color="default"
              iconSize={18}
              onClick={onClick}
              disabled={disabled}
            />
          ) : (
            <Button
              variant="outlined"
              color="default"
              size="small"
              startIcon={<Icon name="plus" />}
              onClick={onClick}
              disabled={disabled}
            >
              Lookalike
            </Button>
          )}
        </Tooltip>
      </Styled.Wrapper>
    );
  }
);

LookalikeButtonBase.displayName = 'LookalikeButton';
